/* eslint-disable max-lines-per-function --
   TODO: 招募前 sprint 拆組件 (TODO-frontend-eslint-ci-warnings-as-errors)。
   2026-02-06 規則加入時 87 個既有違規凍結為 baseline，新檔/新函數仍受 hook 攔截。
*/
// frontend/src/components/Auth/ResetPassword.jsx
// 重設密碼表單組件

import { useState, useEffect } from 'react';
import { useNavigate, useParams, Link as RouterLink } from 'react-router-dom';
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  Link,
  CircularProgress,
  InputAdornment,
  IconButton,
} from '@mui/material';
import {
  Lock as LockIcon,
  Visibility,
  VisibilityOff,
  CheckCircle as CheckCircleIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import authService from '../../services/authService';

const ResetPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  // 密碼驗證狀態
  const passwordValidation = {
    minLength: password.length >= 8,
    hasMatch: password && confirmPassword && password === confirmPassword,
  };

  const isFormValid = passwordValidation.minLength && passwordValidation.hasMatch && !loading;

  useEffect(() => {
    // 檢查是否有 token
    if (!token) {
      setError('無效的重設連結');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!passwordValidation.minLength) {
      setError('密碼長度至少要 8 個字元');
      return;
    }

    if (!passwordValidation.hasMatch) {
      setError('兩次輸入的密碼不一致');
      return;
    }

    setLoading(true);

    try {
      await authService.resetPassword(token, password);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || '重設密碼失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Box sx={{ textAlign: 'center' }}>
        <CheckCircleIcon
          sx={{
            fontSize: 64,
            color: 'success.main',
            mb: 2,
          }}
        />
        <Typography variant="h5" gutterBottom>
          密碼重設成功！
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          您的密碼已成功重設，請使用新密碼登入。
        </Typography>
        <Button
          fullWidth
          variant="contained"
          onClick={() => navigate('/login')}
          sx={{
            py: 1.5,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)',
            },
          }}
        >
          前往登入
        </Button>
      </Box>
    );
  }

  if (!token) {
    return (
      <Box sx={{ textAlign: 'center' }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          無效的重設連結
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          此連結可能已過期或無效。請重新申請密碼重設。
        </Typography>
        <Button fullWidth variant="outlined" onClick={() => navigate('/forgot-password')}>
          重新申請
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 1 }}>
        設定新密碼
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        請輸入您的新密碼。
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="新密碼"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={loading}
          autoComplete="new-password"
          autoFocus
          InputProps={{
            startAdornment: <LockIcon color="action" sx={{ mr: 1 }} />,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          label="確認新密碼"
          type={showConfirmPassword ? 'text' : 'password'}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          disabled={loading}
          autoComplete="new-password"
          error={confirmPassword && !passwordValidation.hasMatch}
          helperText={confirmPassword && !passwordValidation.hasMatch ? '密碼不一致' : ''}
          InputProps={{
            startAdornment: <LockIcon color="action" sx={{ mr: 1 }} />,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />

        {/* 密碼要求提示 */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="caption" color="text.secondary">
            密碼要求：
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
            <CheckCircleIcon
              fontSize="small"
              color={passwordValidation.minLength ? 'success' : 'disabled'}
              sx={{ mr: 0.5 }}
            />
            <Typography
              variant="caption"
              color={passwordValidation.minLength ? 'success.main' : 'text.secondary'}
            >
              至少 8 個字元
            </Typography>
          </Box>
        </Box>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={!isFormValid}
          sx={{
            py: 1.5,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)',
            },
            '&:disabled': {
              background: 'rgba(0, 0, 0, 0.12)',
            },
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : '重設密碼'}
        </Button>

        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Link
            component={RouterLink}
            to="/login"
            variant="body2"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <ArrowBackIcon fontSize="small" sx={{ mr: 0.5 }} />
            返回登入
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default ResetPassword;
